import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api`);

export const getDashboardSummary = async (managerId = null, departmentId = null) => {
  const response = await API.get("/dashboard/", {
    params: {
      manager_id: managerId,
      department_id: departmentId
    }
  });
  return response.data;
};

export default API;